import TitleComponent from '../title/title-component';
import FavouriteSwitchComponent from '../switch/favourite-switch-component';
import HostContainerComponent from '../host/host-container-component';
import AccordionComponent from '../accordion/accordion-component';
import BottomButtonContainer from '../button/bottom-button-container';
import { useState } from 'react';
import CuiInputComponent from '../input/cui-input-component';

const FormContainer: React.FC<any> = ({
    title,
    client,
    handleMainActionMethod,
    bottomButtonDisabled,
    bottomButtonText,
    updateClient,
}: any) => {
    const [host, setHost] = useState('');

    return (
        <>
            <TitleComponent title={title}></TitleComponent>
            <FavouriteSwitchComponent client={client} updateClient={updateClient} />
            <AccordionComponent client={client} updateClient={updateClient} />
            <HostContainerComponent
                client={client}
                host={host}
                setHost={setHost}
                updateClient={updateClient}
            />
            <CuiInputComponent client={client} updateClient={updateClient} />
            <BottomButtonContainer
                disabled={bottomButtonDisabled}
                handleMethod={handleMainActionMethod}
                buttonText={bottomButtonText}
            />
        </>
    );
};

export default FormContainer;
